/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCharactersCharacterIdTitles200Ok
 */
export interface GetCharactersCharacterIdTitles200Ok {
    /**
     * name string
     * @type {string}
     * @memberof GetCharactersCharacterIdTitles200Ok
     */
    name?: string;
    /**
     * title_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdTitles200Ok
     */
    titleId?: number;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdTitles200Ok interface.
 */
export function instanceOfGetCharactersCharacterIdTitles200Ok(value: object): value is GetCharactersCharacterIdTitles200Ok {
    return true;
}

export function GetCharactersCharacterIdTitles200OkFromJSON(json: any): GetCharactersCharacterIdTitles200Ok {
    return GetCharactersCharacterIdTitles200OkFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdTitles200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdTitles200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'titleId': json['title_id'] == null ? undefined : json['title_id'],
    };
}

export function GetCharactersCharacterIdTitles200OkToJSON(json: any): GetCharactersCharacterIdTitles200Ok {
    return GetCharactersCharacterIdTitles200OkToJSONTyped(json, false);
}

export function GetCharactersCharacterIdTitles200OkToJSONTyped(value?: GetCharactersCharacterIdTitles200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'title_id': value['titleId'],
    };
}

